module.exports = __webpack_public_path__ + "img/2.5300b0e5.jpg";